import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadPlannerAccountCategories, deletePlannerAccountCategory} from '../../../../../state/modules/plannerAccountCategories/actions';
import {sendMessage} from '../../../../../state/actions';
import PlannerAccountCategoriesList from '../components/PlannerAccountCategoriesList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.plannerAccountCategories.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['plannerAccountCategories', x]),
              schema.plannerAccountCategory,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.plannerAccountCategories.get('isLoading'),
    total: state.plannerAccountCategories.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadPlannerAccountCategories(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deletePlannerAccountCategory(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const PlannerAccountCategoriesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlannerAccountCategoriesList);

export default PlannerAccountCategoriesListContainer;